import { scrollToElement } from '../utils.js'

export default function scrollTo($initiator) {

  let targetId = $initiator.getAttribute('data-scroll-target')
  if (targetId) {
    let $target = document.getElementById(targetId)
    if ($target) {
      $initiator.addEventListener('click', e => {
        scrollToElement($target, true, 'bottom')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/ui/scroll-to.js